import { createAction, handleActions } from 'redux-actions'

const setFilters = createAction('SCREENS/SUB_PROJECT/SUB_VALUATIONS/SET_FILTERS')
const setFilter = createAction('SCREENS/SUB_PROJECT/SUB_VALUATIONS/SET_FILTER')
const resetFilters = createAction('SCREENS/SUB_PROJECT/SUB_VALUATIONS/RESET_FILTERS')

const defaultState = {
  completionStatuses: [],
}

const reducer = handleActions(
  {
    [setFilters]: (state, { payload }) => payload,
    [setFilter]: (state, { payload }) => ({ ...state, [payload.field]: payload.value }),
    [resetFilters]: () => defaultState,
  },
  defaultState,
)

export { setFilters, setFilter, resetFilters, reducer }
